module.exports = __webpack_public_path__ + "assets/img/office-details-price-icon.a35745d1.svg";